<template>
  <div>
    <h1 class="center icon">🥳</h1>
    <h4 class="center message">Congrats. You've completed all your tasks.</h4>
  </div>
</template>

<style scoped>
.center {
  display: flex;
  justify-content: center;
}

.message {
  color: var(--color-black);
}
</style>
